export default "__VITE_ASSET__B1H4lUr3__";